<template>
  <div class="layout">
    <Layout>
      <Header style="background: #2d8cf0;">
        <Menu mode="horizontal" theme="primary" active-name="1">
          <!--          <div class="layout-logo">-->
          <!--&lt;!&ndash;            <img src="../../assets/froeasy-logo.png">&ndash;&gt;-->
          <!--&lt;!&ndash;            <img src="../../assets/logo2-01.png">&ndash;&gt;-->
          <!--            <span style="color: #FFFFFF;font-size: 20px;"></span>-->
          <!--          </div>-->
          <div class="layout-nav">
            <MenuItem name="2">
              <Icon type="ios-keypad"></Icon>
              {{$t('caseManagement')}}
            </MenuItem>
            <MenuItem name="3" @click.native="startUpload">
              <Icon type="md-cloud-upload" />
<!--              {{$t('caseUpload')}}-->
              {{ $t('caseImport.title') }}
            </MenuItem>
            <MenuItem name="4" @click.native="scanCreate">
              <Icon type="md-qr-scanner" />
              {{ $t('scanAddNewCase.title') }}
            </MenuItem>
            <!--
            <Submenu name="scanSetting">
              <template slot="title">
                <Icon type="ios-construct"></Icon>
                {{$t('scanSettings')}}
              </template>
                <MenuItem name="3-1">{{$t('scanSettingsStart')}}</MenuItem>
                <MenuItem name="3-2">{{$t('scanSettingsSuspend')}}</MenuItem>
                <MenuItem name="3-3">{{$t('scanSettingsStop')}}</MenuItem>
                <MenuItem name="3-4">{{$t('scanSettingsReset')}}</MenuItem>
            </Submenu>
            -->
            <Submenu name="language">
              <template slot="title">
                <Icon type="md-globe"></Icon>
                {{$t('language')}}
              </template>
              <MenuItem name="4-1" @click.native="switchLanguage('zh-CN')">中文简体</MenuItem>
              <MenuItem name="4-2" @click.native="switchLanguage('en-US')">English</MenuItem>
            </Submenu>
            <MenuItem name="4">
              {{$t('welcome')}}！{{userName}}
            </MenuItem>
            <MenuItem name="5" @click.native="logoutConfirm">
              <Icon type="md-exit" />
              {{$t('exit')}}
            </MenuItem>
          </div>
        </Menu>
      </Header>
      <Content :style="{padding: '20px', background: '#fff'}">
        <router-view/>
      </Content>
<!--      <Footer class="layout-footer-center">版权所有 © 2021 南京万起医学科技有限公司 </Footer>-->
    </Layout>
    <div v-if="isShowExcelImport" >
      <Modal v-model="isShowExcelImport"
             :title= "$t('caseImport.title')"
             width="950"
             @on-cancel="getCaseList"
             :footer-hide= "true"
             :mask-closable="false"
             :styles="{top: '20px'}">
        <case-import></case-import>
      </Modal>
    </div>
    <div v-if="isShowScanCreate" >
      <Modal v-model="isShowScanCreate"
             :title= "$t('scanAddNewCase.title')"
             width="1500"
             @on-cancel="getCaseList"
             :footer-hide= "true"
             :mask-closable="false"
             :styles="{top: '20px'}">
        <scan-case />
      </Modal>
    </div>
  </div>
</template>

<script>
import {setI18nLanguage} from '../../utils/lang/index'
import caseImport from '../base/addCase/caseImport'
import scanCase from '../base/addCase/ScanCase'
export default {
  name: 'index',
  components: { caseImport, scanCase },
  data () {
    return {
      $vue: '',
      theme: 'dark',
      userName: '',
      isShowScanCreate: false, // 是否显示扫码新建
      isShowExcelImport: false // 是否显示模态框
    }
  },
  methods: {
    // 是否开启登录页面
    async getLoginStatus () {
      let params = new URLSearchParams()
      let suc = await this.$http.post(this.$vue.getData('GET_LOGIN_STATUS_URL'), params)
      if (suc.data.result === '1') {
        if (suc.data.data.loginStatus === '1' && this.userName === null) {
          this.$router.push({name: 'Login'})
        }
        if (suc.data.data.loginStatus === '0') {
          localStorage.removeItem('userName')
        }
      }
    },
    // 切换语言
    switchLanguage (lang) {
      setI18nLanguage(lang)
      localStorage.setItem('lang', lang)
    },
    // 退出登录确认框
    logoutConfirm () {
      this.$Modal.confirm({
        content: '<p>' + this.$t('exitContent1') + '.</p><p>' + this.$t('exitContent2') + '？</p>',
        title: this.$t('exit'),
        onOk: () => {
          try {
            window.HandleEvent('isLogin', '0')
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
          this.logout()
        }
      })
    },
    // 退出登录
    logout () {
      this.addLoginOutLog()
    },
    // 添加退出日志
    async addLoginOutLog () {
      // 添加退出日志
      let params = new URLSearchParams()
      params.append('userName', this.userName)
      let suc = await this.$http.post(this.$vue.getData('LOGIN_OUT_URL'), params)
      if (suc.data.result === '1') {
        localStorage.removeItem('userId' + this.userName)
        localStorage.removeItem('laboratoryId')
        localStorage.removeItem('userName')
        this.$router.push({name: 'Login'})
      }
    },
    getCaseList () {
      Event.$emit('getCaseListEvent')
    },
    startUpload () {
      /* eslint-disable */
      // AsyncTest.openCaseUpload(0 ,function(str){
      // //alert(str);
      // })
      this.isShowExcelImport = true
		},
    scanCreate () {
     this.isShowScanCreate = true
    }
	},
  beforeMount () {
    this.$vue = this
    this.userName = localStorage.getItem('userName')
    this.getLoginStatus()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .layout{
    /*border: 1px solid #d7dde4;*/
    background: #f5f7f9;
    /*position: relative;*/
    /*border-radius: 4px;*/
    overflow: hidden;
  }
  .layout-logo{
    width: 150px;
    height: 30px;
    float: left;
    position: relative;
    left: 0px;
    font-weight bold;
  }
  .layout-nav{
    /*width: 700px;*/
    width: 980px
    margin: 0 auto;
    margin-right: 20px;
    float: right;
  }
  .layout-footer-center{
    text-align: center;
    bottom 0
  }
  .ivu-layout-footer
    padding 10px 0px
</style>



// WEBPACK FOOTER //
// src/components/case/Index.vue